<template>
  <div class="app app__layout">
    <el-container>
      <!-- Header -->
      <el-header>
        <AppHeader />
      </el-header>

      <!-- Main container -->
      <el-container class="el-container--main">
        <!-- Aside -->
        <AppAside />

        <el-main>
          <!-- Main content goes here -->
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
/* eslint-disable operator-linebreak */
import AppAside from '@/components/App/AppAside';
import AppHeader from '@/components/App/AppHeader';
import { transformTranslations } from '@/shared/transformers';
import * as Browser from '@/services/browser';
import { mapGetters } from 'vuex';

export default {
  name: 'AppLayout',

  components: {
    AppAside,
    AppHeader
  },

  computed: {
    ...mapGetters({
      asideIsVisible: `aside/isVisible`,
      company: `user/company`,
      menuIsCollapsed: `menu/isCollapsed`,
      user: `user/currentUser`
    })
  },

  created() {
    this.init();
  },

  methods: {
    handleCheckGdpr() {
      if (this.user.hasAcceptedGdpr) {
        return true;
      }

      // Call API for GDPR text and show dialog
      this.$store
        .dispatch('GET_PRIVACYPOLICY')
        .then(response => {
          if (response.data.hasOwnProperty('hasError') && !response.data.hasError) {
            this.$store.commit('dialog/OPEN', {
              title: this.$t('Privacy policy'),
              width: '50%',
              data: response.data,
              loadComponent: () => import(/* webpackChunkName: "formprivacypolicy" */ '@/components/Form/FormPrivacyPolicy.vue')
            });
          }
        })
        .catch(err => {
          // err
        });
    },

    handleLanguage() {
      const language = Browser.getLanguage();
      let lang = language.toLowerCase();

      if (this.user.locale) {
        lang = this.user.locale.slice(0, 2);
      }

      this.$store.dispatch('GET_TRANSLATION', lang).then(response => {
        const message = transformTranslations(response.data);
        console.log(message);

        this.$store.commit('SET_TRANSLATION', { locale: lang, message });
      });
    },

    handleResizeFromDesktopToMobile() {
      if (this.menuIsCollapsed && !this.asideIsVisible) {
        this.$store.commit('menu/TOGGLE');
        this.$store.commit('aside/HIDE');
      }
    },

    handleResize() {
      const header = document.querySelector('.el-header');
      const mainContainer = document.querySelector('.el-container--main');

      if (!header || !mainContainer) {
        return;
      }
      const headerHeight = header.clientHeight;
      mainContainer.style.height = `calc(100vh - ${headerHeight}px)`;
    },

    handleToken() {
      const directus_sdk =
        localStorage.getItem('directus-sdk-js') !== undefined ? JSON.parse(localStorage.getItem('directus-sdk-js')) : null;
      const directus_token = directus_sdk && directus_sdk.token ? directus_sdk.token : null;
      localStorage.setItem('token', directus_token);
    },

    init() {
      this.registerEvents();
      this.handleToken();

      setTimeout(() => {
        this.requestInitialData();
      }, 500);

      const body = document.querySelector('body');
      body.style.overflow = 'hidden';
    },

    registerEvents() {
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(entries => {
          for (let entry of entries) {
            const cr = entry.contentRect;

            if (cr.width < 992) {
              this.handleResizeFromDesktopToMobile();
            }

            this.handleResize();
          }
        });

        ro.observe(document.querySelector('body'));
      } else {
        window.addEventListener('resize', event => {
          this.handleResize();
        });
      }
    },

    async requestInitialData() {
      this.$store.commit('SET_TOGGLE_LOADING');

      this.$store.dispatch('templates/GET_CATEGORIES');

      try {
        await this.$store.dispatch('user/GET_CURRENT_USER');
        this.$store.dispatch('bb_widgets/GET_WIDGETS_FOR_COMPANY', { id: this.company.id });
        // this.handleCheckGdpr();
        this.handleLanguage();
        this.$store.commit('HIDE_LOADING');
      } catch (error) {
        throw new Error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  position: relative;

  &--main {
    height: calc(100vh - 74px);

    @media screen and (min-width: $screen-md) {
      height: calc(100vh - 79px);
    }
  }
}

.el-header {
  background-color: #ffffff;
  border-bottom: 1px solid $c-medium-gray;
  height: auto !important;
  padding-top: 0.7rem !important;
  padding-bottom: 0.7rem !important;
}

.el-dialog--open {
  .el-main {
    overflow: hidden;
  }
}

.el-main {
  background-color: $c-page-bg;
  padding: 0rem !important;
  position: relative;
}
</style>
